
(function(){
  "use strict";
  var doc = document;
  var win = window;
  var book = doc.getElementById('tsm-book');
  if (!book) return;
  var main = doc.getElementById('tsm-book-main');

  /* Header title, back to top */
  var headerTitleBtn = doc.getElementById('tsm-header-title');
  var headerTitleText = doc.getElementById('tsm-header-title-text');
  (function setHeaderTitleFromDocumentTitle(){
    var raw = (doc.title || '').split(':')[0].trim();
    if (raw){ headerTitleText.textContent = raw; }
  })();
  headerTitleBtn.addEventListener('click', function(){
    win.scrollTo({ top: 0, behavior: 'smooth' });
  });

  /* TOC overlay open and close, Esc, focus return, scroll lock */
  var tocOverlay = doc.getElementById('tsm-toc-overlay');
  var tocToggle = doc.getElementById('tsm-toc-toggle');
  var tocClose = doc.getElementById('tsm-toc-close');
  var scrollLockY = 0;

  function lockScroll(){
    scrollLockY = win.scrollY || win.pageYOffset || 0;
    doc.documentElement.style.overflow = 'hidden';
  }
  function unlockScroll(){
    doc.documentElement.style.overflow = '';
  }
  function openToc(){
    tocOverlay.classList.add('is-open');
    tocOverlay.setAttribute('aria-hidden', 'false');
    tocToggle.setAttribute('aria-expanded', 'true');
    lockScroll();
    var firstLink = tocOverlay.querySelector('a');
    if (firstLink){ firstLink.focus(); }
  }
  function closeToc(){
    tocOverlay.classList.remove('is-open');
    tocOverlay.setAttribute('aria-hidden', 'true');
    tocToggle.setAttribute('aria-expanded', 'false');
    unlockScroll();
    tocToggle.focus();
  }
  tocToggle.addEventListener('click', function(){
    tocOverlay.classList.contains('is-open') ? closeToc() : openToc();
  });
  tocClose.addEventListener('click', closeToc);
  tocOverlay.addEventListener('click', function(e){
    var link = e.target.closest ? e.target.closest('a') : null;
    if (link){ closeToc(); }
  });
  doc.addEventListener('keydown', function(e){
    var tag = (doc.activeElement && doc.activeElement.tagName) || '';
    var typing = tag === 'INPUT' || tag === 'TEXTAREA' || (doc.activeElement && doc.activeElement.isContentEditable);
    if (e.key === 'Escape' && tocOverlay.classList.contains('is-open')){
      closeToc();
      return;
    }
    if (!typing && e.key === 't' && !e.metaKey && !e.ctrlKey && !e.altKey){
      tocOverlay.classList.contains('is-open') ? closeToc() : openToc();
    }
  });

  /* Chapter tracking for the header label and the active TOC row */
  var chapterOpens = Array.prototype.slice.call(main.querySelectorAll('.tsm-b-chapter-open'));
  var headerChapterLabel = doc.getElementById('tsm-header-chapter');
  var totalChapters = chapterOpens.length;
  var tocLinks = Array.prototype.slice.call(tocOverlay.querySelectorAll('a[href^="#"]'));

  function setActiveTocRow(id){
    tocLinks.forEach(function(a){
      a.classList.toggle('is-active', a.getAttribute('href') === '#' + id);
    });
  }

  if ('IntersectionObserver' in win && chapterOpens.length){
    var chapterObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting){
          var n = entry.target.getAttribute('data-chapter');
          headerChapterLabel.textContent = 'Chapter ' + n + ' of ' + totalChapters;
          headerChapterLabel.classList.add('is-visible');
          setActiveTocRow(entry.target.id);
        }
      });
    }, { rootMargin: '0px 0px -70% 0px', threshold: 0 });
    chapterOpens.forEach(function(el){ chapterObserver.observe(el); });
  }

  /* Running foot + vertical side label (spec 3c-b, v4). Generated at
     runtime, no new template variables needed: walk the built page
     once, remember the nearest chapter-open behind the cursor, and
     stamp a foot onto every long-form block (text, text-image, plate)
     with the book title, that chapter's title, and a same-page block
     count the script assigns itself by counting in DOM order. The
     vertical label in the freed left margin (see the desktop offset
     rule) repeats that chapter's own {{side_label}}, already rendered
     onto the chapter-open section as data-side-label so no new markup
     contract is needed for it either. v3 used this same block to wrap
     the first three words of a chapter's opening paragraph in small
     caps; that effect paired with the old serif body and does not suit
     the new sans one, so it is gone, not replaced. */
  (function buildRunningFeatures(){
    var longBlocks = main.querySelectorAll('.tsm-b-text, .tsm-b-text-image, .tsm-b-plate');
    if (!longBlocks.length) return;
    var bookName = (headerTitleText.textContent || '').trim();
    var currentTitle = '';
    var currentSideLabel = '';
    var count = 0;
    Array.prototype.slice.call(main.children).forEach(function(el){
      if (!el.classList) return;
      if (el.classList.contains('tsm-b-chapter-open')){
        var titleEl = el.querySelector('.tsm-chapter-title2');
        currentTitle = titleEl ? titleEl.textContent.trim() : '';
        currentSideLabel = el.getAttribute('data-side-label') || '';
        return;
      }
      var isLong = el.classList.contains('tsm-b-text') ||
        el.classList.contains('tsm-b-text-image') ||
        el.classList.contains('tsm-b-plate');
      if (!isLong) return;

      count += 1;
      var num = (count < 10 ? '0' : '') + count;

      var foot = doc.createElement('div');
      foot.className = 'tsm-runfoot';
      foot.setAttribute('aria-hidden', 'true');
      var left = doc.createElement('span');
      left.className = 'tsm-runfoot-left';
      var bookSpan = doc.createElement('span');
      bookSpan.className = 'tsm-runfoot-book';
      bookSpan.textContent = bookName;
      var divSpan = doc.createElement('span');
      divSpan.className = 'tsm-runfoot-div';
      divSpan.textContent = '|';
      var chapSpan = doc.createElement('span');
      chapSpan.className = 'tsm-runfoot-chapter';
      chapSpan.textContent = currentTitle;
      left.appendChild(bookSpan);
      left.appendChild(divSpan);
      left.appendChild(chapSpan);
      var numSpan = doc.createElement('span');
      numSpan.className = 'tsm-runfoot-num';
      numSpan.textContent = num;
      foot.appendChild(left);
      foot.appendChild(numSpan);
      el.appendChild(foot);

      var vert = doc.createElement('span');
      vert.className = 'tsm-sidevert';
      vert.setAttribute('aria-hidden', 'true');
      vert.textContent = currentSideLabel;
      el.appendChild(vert);
    });
  })();

  /* Opening page marker. The book intro reuses the chapter-open mold
     with num_pad left empty, per spec 3b that page's marker line
     reads "OPENING" instead of "CHAPTER" plus a blank number, and its
     ghost numeral is skipped entirely (handled by :empty in CSS). */
  chapterOpens.forEach(function(openEl){
    var numSpan = openEl.querySelector('.tsm-chapter-marker-num');
    var leftSpan = openEl.querySelector('.tsm-chapter-marker-left');
    if (leftSpan && numSpan && !numSpan.textContent.trim()){
      leftSpan.textContent = 'OPENING';
    }
  });

  /* Fade up reveal, one time, reduced motion aware */
  if ('IntersectionObserver' in win){
    if (win.matchMedia('(prefers-reduced-motion: no-preference)').matches){
      var revealObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting){
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.08 });
      book.querySelectorAll('.tsm-reveal').forEach(function(el){ revealObserver.observe(el); });
    } else {
      book.querySelectorAll('.tsm-reveal').forEach(function(el){ el.classList.add('is-in'); });
    }
  }

  /* Parallax, spread images only, desktop and motion allowed only.
     A full book runs 9 chapters and 15 to 20 spread images, scattered
     across roughly 12,000 words. Reading getBoundingClientRect for
     every spread on every scroll frame, most of them nowhere near the
     viewport, does not scale. An IntersectionObserver keeps a small
     "nearby" list (usually zero to two images) and the scroll handler
     only ever measures and transforms that list. */
  var parallaxEls = Array.prototype.slice.call(main.querySelectorAll('.tsm-spread-media[data-parallax] img'));
  var desktopMotionQuery = win.matchMedia('(min-width:900px)');
  var reducedMotionQuery = win.matchMedia('(prefers-reduced-motion: no-preference)');
  var parallaxTicking = false;
  var parallaxNearby = [];

  function parallaxAllowed(){
    return desktopMotionQuery.matches && reducedMotionQuery.matches;
  }
  function updateParallax(){
    parallaxTicking = false;
    if (!parallaxAllowed() || !parallaxNearby.length) return;
    var vh = win.innerHeight;
    parallaxNearby.forEach(function(img){
      var box = img.parentElement.getBoundingClientRect();
      var progress = (box.top + box.height / 2 - vh / 2) / vh;
      var maxShift = box.height * 0.06;
      var shift = Math.max(-maxShift, Math.min(maxShift, -progress * maxShift * 2));
      img.style.transform = 'translateY(' + shift.toFixed(2) + 'px)';
    });
  }
  function requestParallaxUpdate(){
    if (!parallaxTicking && parallaxAllowed() && parallaxNearby.length){
      win.requestAnimationFrame(updateParallax);
      parallaxTicking = true;
    }
  }
  function resetParallax(){
    parallaxEls.forEach(function(img){ img.style.transform = ''; });
  }

  if ('IntersectionObserver' in win && parallaxEls.length){
    var parallaxWatcher = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var img = entry.target;
        var idx = parallaxNearby.indexOf(img);
        if (entry.isIntersecting){
          if (idx === -1){ parallaxNearby.push(img); }
        } else {
          if (idx !== -1){ parallaxNearby.splice(idx, 1); }
          img.style.transform = '';
        }
      });
      requestParallaxUpdate();
    }, { rootMargin: '50% 0px 50% 0px', threshold: 0 });
    parallaxEls.forEach(function(img){ parallaxWatcher.observe(img); });
  }

  win.addEventListener('scroll', requestParallaxUpdate, { passive: true });
  win.addEventListener('resize', function(){
    if (parallaxAllowed()){ requestParallaxUpdate(); } else { resetParallax(); }
  });

  /* Progress bar, JS fallback for browsers without scroll timelines */
  var supportsScrollTimeline = win.CSS && win.CSS.supports && win.CSS.supports('animation-timeline: scroll()');
  if (!supportsScrollTimeline){
    var bar = doc.getElementById('tsm-progress-bar');
    var barTicking = false;
    function updateBar(){
      var docEl = doc.documentElement;
      var max = docEl.scrollHeight - docEl.clientHeight;
      var pct = max > 0 ? (win.scrollY / max) : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, pct)) + ')';
      barTicking = false;
    }
    win.addEventListener('scroll', function(){
      if (!barTicking){ win.requestAnimationFrame(updateBar); barTicking = true; }
    }, { passive: true });
    updateBar();
  }

  /* Resume position, localStorage only, never auto jumps */
  var STORE_KEY = 'tsm-book-position';
  var resumeBar = doc.getElementById('tsm-resume-bar');
  var resumeLabel = doc.getElementById('tsm-resume-label');
  var resumeGo = doc.getElementById('tsm-resume-go');
  var resumeDismiss = doc.getElementById('tsm-resume-dismiss');
  var resumeTarget = null;

  try {
    var saved = win.localStorage.getItem(STORE_KEY);
    if (saved){
      var data = JSON.parse(saved);
      if (data && data.id){
        var targetEl = doc.getElementById(data.id);
        if (targetEl){
          resumeTarget = targetEl;
          resumeLabel.textContent = data.label || '';
          resumeBar.hidden = false;
        }
      }
    }
  } catch (e) {}

  resumeGo.addEventListener('click', function(){
    if (resumeTarget){ resumeTarget.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    resumeBar.hidden = true;
  });
  resumeDismiss.addEventListener('click', function(){
    resumeBar.hidden = true;
    try { win.localStorage.removeItem(STORE_KEY); } catch (e) {}
  });

  var saveTicking = false;
  var trackedSections = Array.prototype.slice.call(main.querySelectorAll('section[id], section[data-block="chapter-open"]'));
  function saveProgress(){
    var current = null;
    for (var i = 0; i < trackedSections.length; i++){
      var rect = trackedSections[i].getBoundingClientRect();
      if (rect.top <= win.innerHeight * 0.5){ current = trackedSections[i]; } else { break; }
    }
    if (current && current.id){
      var titleEl = current.querySelector('.tsm-chapter-title2, .tsm-section-title2');
      var label = titleEl ? titleEl.textContent : current.id;
      try { win.localStorage.setItem(STORE_KEY, JSON.stringify({ id: current.id, label: label })); } catch (e) {}
    }
    saveTicking = false;
  }
  win.addEventListener('scroll', function(){
    if (!saveTicking){ win.requestAnimationFrame(function(){ win.setTimeout(saveProgress, 120); }); saveTicking = true; }
  }, { passive: true });

})();
